import { useCallback, useId } from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { FormGroup, Input } from '@theneatcompany/nui'

import { getMessage } from '@/utils/messages'

import FieldCounter from './FieldCounter'
import FieldError from './FieldError'

const InputField = ({
  labelProps = {},
  label = labelProps.label,
  errorProps = {},
  name,
  maxLength,
  showCounter = false,
  onChange,
  ...inputProps
}) => {
  const id = useId()
  const placeholder = inputProps.placeholder || getMessage('placeholders.default', { label })

  const [{ value = '', ...field }, { error, touched, initialValue }, { setValue, setTouched }] = useField(name)

  const handleInputChange = useCallback(({ target: { value: val } }) => {
    if (onChange) onChange(val)
    if (val === '' && initialValue === undefined) {
      setValue(undefined)
      return
    }
    setValue(val)
  }, [initialValue, onChange])

  const hasErrors = !!(error && touched)

  return (
    <FormGroup intent={hasErrors ? 'danger' : 'default'}>
      <FormGroup.Label htmlFor={id} label={label} {...labelProps} />
      <Input
        {...inputProps}
        id={id}
        placeholder={placeholder}
        {...field}
        onBlur={setTouched}
        onChange={handleInputChange}
        value={value}
      />
      <FieldError message={error} label={label} touched={touched} {...errorProps} />
      {showCounter && <FieldCounter value={value ? value.length : 0} maxLength={maxLength} />}
    </FormGroup>
  )
}

InputField.propTypes = {
  label: PropTypes.node,
  labelProps: PropTypes.shape({
    label: PropTypes.node,
  }),
  errorProps: PropTypes.shape({
    onRender: PropTypes.func,
  }),
  showCounter: PropTypes.bool,
  name: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
}

export default InputField
